import React, { useState } from "react";
import AddFBIntegtarion from "../FBIntegration";
import MessagingIntegration from "../MessagingIntegration";
import ChannelIntegration from "../ChannelIntegration";
import { SaIntegrationSubTabs } from "../shared/SuperAdminUi";

const INTEGRATION_TABS = [
  { key: "facebookAds", label: "Facebook Ads", icon: "fab fa-facebook", iconColor: "#1877F2" },
  { key: "googleAds", label: "Google Ads", icon: "fab fa-google", iconColor: "#4285F4" },
  { key: "linkedin", label: "LinkedIn", icon: "fab fa-linkedin", iconColor: "#0A66C2" },
  { key: "instagram", label: "Instagram", icon: "fab fa-instagram", iconColor: "#C13584" },
  { key: "ninetyNineAcres", label: "99acres", icon: "fas fa-city", iconColor: "#E84545" },
  { key: "messaging", label: "SMS & WhatsApp", icon: "fas fa-comment-dots", iconColor: "#5e72e4" },
];

const CHANNEL_TAB_KEYS = {
  googleAds: "GoogleAds",
  linkedin: "LinkedIn",
  instagram: "Instagram",
  ninetyNineAcres: "NinetyNineAcres",
};

function ClientIntegrationPanel({ clientId }) {
  const [activeIntegrationTab, setActiveIntegrationTab] = useState("facebookAds");

  return (
    <div style={{ marginTop: "4px" }}>
      <SaIntegrationSubTabs
        tabs={INTEGRATION_TABS}
        activeKey={activeIntegrationTab}
        onChange={setActiveIntegrationTab}
      />

      {activeIntegrationTab === "facebookAds" && <AddFBIntegtarion ClientId={clientId} />}

      {CHANNEL_TAB_KEYS[activeIntegrationTab] && (
        <ChannelIntegration ClientId={clientId} channelKey={CHANNEL_TAB_KEYS[activeIntegrationTab]} />
      )}

      {activeIntegrationTab === "messaging" && <MessagingIntegration ClientId={clientId} />}
    </div>
  );
}

export default ClientIntegrationPanel;
